import { render } from "./Desplegable.vue?vue&type=template&id=683baf40&scoped=true"
import script from "./Desplegable.vue?vue&type=script&lang=js"
export * from "./Desplegable.vue?vue&type=script&lang=js"

import "./Desplegable.vue?vue&type=style&index=0&id=683baf40&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-683baf40"

export default script